// extracted by css-extract-rspack-plugin
export default {"Heading":"K1L4C","SidebarHeader":"nGI17","SidebarBody":"wG15w","SidebarFooter":"cPycU"};